import { fromDateInputValue, toDateInputValue } from "./date";

export const WEEKDAYS_SHORT = ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub", "Ned"];
export const WEEKDAYS_LONG = ["Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota", "Nedelja"];

/** Monday = 0 ... Sunday = 6 for a "yyyy-MM-dd" string. */
export function weekdayIndex(dateStr) {
  const d = fromDateInputValue(dateStr);
  return d ? (d.getDay() + 6) % 7 : 0;
}

export function addDays(dateStr, n) {
  const d = fromDateInputValue(dateStr);
  d.setDate(d.getDate() + n);
  return toDateInputValue(d);
}

/** "09.10." for chart labels, "09.10.2026" for tables. */
export function shortDate(dateStr) {
  const [, m, d] = dateStr.split("-");
  return `${d}.${m}.`;
}
export function longDate(dateStr) {
  const [y, m, d] = dateStr.split("-");
  return `${d}.${m}.${y}.`;
}

/** Every calendar day from start to end (inclusive), with zeros for days without receipts. */
export function fillDays(start, end, rows) {
  const byDay = new Map((rows || []).map((r) => [String(r.datum).slice(0, 10), r]));
  const out = [];
  for (let d = start, guard = 0; d <= end && guard < 1200; d = addDays(d, 1), guard++) {
    const r = byDay.get(d);
    out.push({ date: d, total: r ? Number(r.vrednost) || 0 : 0, bills: r ? Number(r.racuna) || 0 : 0 });
  }
  return out;
}

/** Best day, weakest day (among days with sales), average per day with sales. */
export function dayStats(days) {
  const sold = days.filter((d) => d.total > 0);
  if (sold.length === 0) return null;
  const best = sold.reduce((a, b) => (b.total > a.total ? b : a));
  const worst = sold.reduce((a, b) => (b.total < a.total ? b : a));
  const sum = sold.reduce((s, d) => s + d.total, 0);
  return { best, worst, average: sum / sold.length, soldDays: sold.length };
}
